import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'react-use';

import { DialogHeader } from '../../../../components/Dialog/DialogUiRedesign/DialogHeader';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { auth } from '../../../../services/auth';
import { useStores } from '../../../../stores/useStores';
import type { ChooseCountryProps } from '../../ChooseCountryDialog/types';
import { RedesignContainer } from '../RedesignContainer/RedesignContainer';

import { ChooseCountryComponentRedesign } from './ChooseCountryComponentRedesign';
import styles from './ChooseCountryRedesign.module.scss';

export const ChooseCountryWizardStepRedesign = observer(function ChooseCountryWizardStepRedesign(
  props: ChooseCountryProps,
) {
  const [_signUpMarketingConsentsLS, _setSignUpMarketingConsentsLS, removeSignUpMarketingConsentsLS] = useLocalStorage<
    Record<string, boolean>
  >('signup-marketing-consents', {});
  const { portalStore } = useStores();
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width: 768px)');

  const onClose = async () => {
    removeSignUpMarketingConsentsLS();
    await auth.signOut();
    portalStore.closePortal();
  };

  return (
    <RedesignContainer className={styles.container}>
      <DialogHeader
        className={styles.dialogHeader}
        decorationsWrapperClassName={styles.dialogHeaderDecorationsWrapperClassName}
        title={
          t('settings.chooseYourSettings').charAt(0).toUpperCase() +
          t('settings.chooseYourSettings').slice(1).toLowerCase()
        }
        titleClassName={styles.dialogHeaderTitle}
        titleDataTestId="email-verification-title"
        {...(isDesktop ? { onClose: onClose } : { onGoBack: onClose })}
      />
      <ChooseCountryComponentRedesign {...props} componentType="portal" />
    </RedesignContainer>
  );
});
